import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * How many repos the Runtime page lists, for its nav badge. `undefined` until the
 * fetch resolves, which is what keeps the badge from flashing a 0.
 *
 * Counts EVERY eligible repo, not just the started ones — so the badge matches
 * what you see on clicking through, the same way the Sessions badge counts
 * sessions rather than active ones.
 *
 * Fetched only for admins, mirroring useOrgCounts: the Runtime route is
 * admin-only and the API 403s everyone else, so a non-admin would pay a request
 * to be told no. The sidebar is mounted on every page, and this read walks the
 * corpus server-side, so it is deliberately fetched once on mount rather than
 * kept live — the total changes only when a repo gains or loses `.agents/`
 * content, which no runtime event signals.
 */
export function useRuntimeCount(admin: boolean): number | undefined {
  const [count, setCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!admin) {
      setCount(undefined);
      return;
    }
    let cancelled = false;
    api
      .getAgentRuntimes()
      .then((d) => {
        if (!cancelled) setCount(d.total);
      })
      // A failed count leaves the badge absent rather than showing a wrong number:
      // the nav is not the place to report an outage, and the page itself says so.
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [admin]);

  return count;
}
